var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    'comment-wrapper': true,
    'is-flex': true,
    'comment-wrapper--highlighted': _vm.isHighlighted
  }, _obj[_vm.customClass] = _vm.customClass, _obj )},[_c('UserAvatar',{attrs:{"user":_vm.commenter,"size":"small"}}),_c('div',{staticClass:"u-m-l-small"},[_c('div',{staticClass:"is-flex is-align-items-flex-end"},[_c('UserDisplayName',{attrs:{"activeUserId":_vm.commenter.id}}),_c('small',{staticClass:"u-m-l-xsmall"},[_vm._v(" "+_vm._s(new Date(_vm.comment.createdAt).toLocaleDateString(_vm.$i18n.locale, {}))+" "+_vm._s(new Date(_vm.comment.createdAt).toLocaleTimeString(_vm.$i18n.locale, {}))+" ")])],1),_c('p',[_vm._v(" "+_vm._s(_vm.comment.content)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }